import { createFileRoute } from '@tanstack/react-router';
import { CheckInDesk } from '@/lib/desk/ui/CheckInDesk';

// The reception desk (Task 14). Its component — scanner, lookup, balance UI —
// is split into its own chunk by the router plugin's automatic code
// splitting; the sync engine it drives lives in the eager shell so queued
// events keep syncing on every screen.
export const Route = createFileRoute('/check-in')({
  component: CheckInDesk,
});
